import React from 'react';
import {OrderByOptions, OrderByOptionsWithoutPrepayment} from './utilities';
import classNames from 'classnames';
import {useLocation} from 'react-router-dom';
interface SortFormProps {
  sortFilter: string;
  setsortFilter: (sortFilter: string) => void;
  setIsSortOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const SortForm = ({
  sortFilter,
  setsortFilter,
  setIsSortOpen,
}: SortFormProps) => {
  const {state} = useLocation();
  return (
    <div className="flex flex-col w-full items-start px-4 gap-6 py-4">
      {state?.type === 'prepayment'
        ? OrderByOptionsWithoutPrepayment.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                setsortFilter(item.value);
                setIsSortOpen(false);
              }}
              className={classNames(
                'text-[16px] font-medium',
                {
                  'text-primary': item.value === sortFilter,
                },
                {
                  'text-gray-5': item.value !== sortFilter,
                },
              )}
            >
              {item.name}
            </button>
          ))
        : OrderByOptions.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                setsortFilter(item.value);
                setIsSortOpen(false);
              }}
              className={classNames(
                'text-[16px] font-medium',
                {
                  'text-primary': item.value === sortFilter,
                },
                {
                  'text-gray-5': item.value !== sortFilter,
                },
              )}
            >
              {item.name}
            </button>
          ))}
    </div>
  );
};

export default SortForm;
